import { RESET_STATE, UPDATE_STATS, UPDATE_GRAPH_STATS, ACTION_LOGOUT_INITIATED } from '../actions/types';

const initialState = {
	stats: null,
	graph_stats: [],
};

export default function (state = initialState, action) {
	switch (action.type) {
		case RESET_STATE:
			return initialState;

		case UPDATE_STATS:
			return {
				...state,
				stats: action.payload,
			};

		case UPDATE_GRAPH_STATS:
			return {
				...state,
				graph_stats: action.payload,
			};

		case ACTION_LOGOUT_INITIATED:
			return initialState;	
			
		default:
			return state;
	}
}
